import React from "react";
import { node } from "prop-types";

import * as S from "./styled";

const List = ({ children, ...props }) => (
  <S.List data-react-component {...props}>
    {children}
  </S.List>
);

List.propTypes = {
  children: node.isRequired
};

export default List;
